/* eslint-disable */

import $ from 'jquery';
import loadingLayer from '../../util/loadingLayer';
import formMessages from '../../util/formMessages';
import stateAndCountry from '../../util/stateAndCountry';

export default {
	init() {
		formMessages().useCaptcha();
		const $form = $('#ticket-registration-form');
		const url = $form.attr('action-ajax') || $form.attr('action');
		const method = $form.attr('method');
		var data = {};

		$('.conference-registration-fee-type').on('click', function (event) {
			event.stopImmediatePropagation();
			event.preventDefault();

			const val = $(this).data('fee-type');
			$('#registration_type', $form).val(val)
			formMessages().scrollTo($form, 1000, 120);
		});

		stateAndCountry($form);
		formMessages($form).validate();

		$form.on('submit', function (event) {
			event.stopImmediatePropagation();
			event.preventDefault();

			loadingLayer.showLoading();
			formMessages($form).init();

			const formData = $form.find("select:visible,input[type=hidden],:input:visible,textarea:visible").serializeArray();

			for (var i in formData) {
				data[formData[i].name] = formData[i].value;

				$('#' + formData[i].name, $form).removeClass('is-invalid');
				$('#' + formData[i].name + ' ~ .invalid-feedback', $form).text('');
			}

			$.ajax({
				url,
				method,
				data: {
					...data,
					nonce: window.meta_object.nonce,
					captcha_token: window.meta_object.captcha_token,
					action: 'ticket-registration-code',
				},
				dataType: 'json',
			}).always(() => {
				formMessages().reloadCaptcha();
			}).fail(() => {
				loadingLayer.hideLoading();
			}).done((validateData) => {
				if (validateData && !validateData.success) {
					loadingLayer.hideLoading();
					formMessages($form, validateData).run();
					return;
				}

				if (validateData.data.ecrypt_btn) {
					$("#eway-ecrypt").html(validateData.data.ecrypt_btn);
					console.log(...data);
					loadingLayer.hideLoading();
					setTimeout(function () {
						$("#btn-eway-payment").click();
					}, 500);
				}
			});
			/* end of ajax function */
		});

		/* eway payment */
		$("#btn-eway-payment").on("click", function () {
			eCrypt.showModalPayment(eWAYConfig, function (result, transactionID, errors) {
				if (result == "Complete") {
					// Donate
					$.ajax({
						url,
						method: 'post',
						data: {
							...data,
							nonce: window.meta_object.nonce,
							captcha_token: window.meta_object.captcha_token,
							action: 'ticket-registration',
						},
						dataType: 'json'
					}).always(() => {
						formMessages().reloadCaptcha();
					}).done((result) => {
						if (result.success) {
							if (result.successUrl) {
								window.location.replace(result.successUrl);
								loadingLayer.hideLoading();
								return;
							}
						}
					}).fail((err) => {
						loadingLayer.hideLoading();
						console.log(err);
					});
				} else if (result == "Error") {
					formMessages($form, {
						success: false,
						message: 'Please check your credit/debit card information and try again.',
					}).run();
				}
			});
		});
		/* end of function */
	},
	finalize() {

	},
};



// WEBPACK FOOTER //
// ./scripts/routes/blocks/ticketRegistration.js